import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const STATUS_OPTIONS = [
  {
    label: 'موفق',
    value: 'true',
  },
  {
    label: 'ناموفق',
    value: 'false',
  },
];

const filters = (currencyText) => [
  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'محدوده زمان فراخوانی',
    label: {
      start: 'از زمان',
      end: 'تا زمان',
    },
    keyName: 'timeRange',
    id: {
      start: 1439,
      end: 1440,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.timeRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'شناسه سرویس',
    label: 'شناسه سرویس',
    keyName: 'serviceId',
    id: 1310,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نام سرویس',
    label: 'نام سرویس',
    keyName: 'serviceName',
    id: 1306,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'بر اساس وضعیت',
    label: 'وضعیت فراخوانی',
    keyName: 'status',
    id: 1441,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'نام سرویس‌گیرنده',
    label: 'نام سرویس‌گیرنده',
    keyName: 'serviceReceiver',
    id: 1307,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'محدوده‌ قیمت',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'price',
    id: {
      start: 1308,
      end: 1309,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'شماره فاکتور',
    label: 'شماره فاکتور',
    keyName: 'invoiceId',
    id: 1311,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
];

export default filters;
